/* eslint-disable */
import {
  Box,
  Button,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
  Tooltip,
  Typography,
  Autocomplete,
  Fab,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useEffect, useState } from "react";
import Message from "../../../utils/Message";
import {
  getPersonasFisicasHistorial,
} from "../../../services/PersonaFisicaService";
import { useNavigate } from "react-router-dom";
import "../../../core/styles/busqueda.css";
import { getPersonasJuridicas, getPersonasJuridicasHistorial } from "../../../services/PersonaJuridicaService";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';



const initialSearchData = {
  id: null,
  razon_social: "",
  cuit: "",
  email: "",
  numero_inscripcion: "",
  tipo_societario: "",
  fecha_contrato_social: null,
  domiclios: "",
  telefonos: "",
};

const nameItemsText = "Historial de Personas Jurídicas";
//
// #############################################################################  
//
const PersonaJuridicaHistorialTable = () => {
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [personas, setPersonas] = useState([]);
  const [PersonaSelected, setPersonaSelected] = useState([]);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [_idPersona, set_idPersona] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  const tableColumns = [
    {
      name: "id",
      label: "ID",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cuit",
      label: "Cuit",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        })
      },

    },
    {
      name: "razon_social",
      label: "Razón Social",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            fontSize: '12px'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        }),
        customBodyRender: (value) => {
          // pasa el valor a mayusculas
          return value.toUpperCase();
        }
      },
    },

    {
      name: "email",
      label: "Correo Electrónico",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        })
      },
    },
    {
      name: "numero_inscripcion",
      label: "N° de Inscripción",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        })
      },
    },
    {
      name: "tipo_societario",
      label: "Tipo Societario",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            fontSize: '12px'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        }),
        customBodyRender: (value) => {
          let _val = ""
          _val = value['descripcion']
          if (_val) _val = _val.toUpperCase()
          return _val;
        }
      },
    },
    {
      name: "actions",
      label: "Acciones",
      options: {
        filter: false,
        sort: false,
        empty: true,
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        }),
        customBodyRenderLite: (dataIndex, rowIndex) => (
          <>

            <Tooltip title="Ver Persona">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => obtienePersona(dataIndex, "view")}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>

            </Tooltip>
            {/* <Tooltip title="Editar Persona">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => editaPersona(dataIndex, "edit")}
              >
                <Edit />
              </IconButton>
            </Tooltip> */}
          </>
        ),
      },
    },
  ];

  const tiposSocietariosOptions = [
    { label: "Res. Limitada", value: "Res. Limitada" },
    { label: "Soc. Anonima", value: "Soc. Anónima" },
    { label: "Soc. Acc. Simpl.", value: "Soc. Acc- Simpl-" },
    { label: "Asoc. Civil", value: "Aso. Civil" },
    { label: "Fundacion", value: "Fundación" }
  ];

  const tableOptions = {
    download: false,
    filter: false,
    print: false,
    search: false,
    viewColumns: false,
    elevation: 5,
    // Controls the visibility of the Select Toolbar
    selectToolbarPlacement: "none",
    // Show/hide the select all/deselect all checkbox header for selectable rows
    selectableRowsHeader: false,
    // Hides the checkboxes that appear when selectableRows is set to "multiple" or "single"
    selectableRowsHideCheckboxes: false,
    // Indicates if rows can be selected. Options are "multiple", "single", "none"
    selectableRows: "none",

    // Callback function that triggers when row(s) are selected/deselected
    onRowSelectionChange: (
      currentRowsSelected,
      allRowsSelected,
      rowsSelected
    ) => {
      seleccionarPersona(currentRowsSelected, allRowsSelected, rowsSelected);
    },
    // User provided array of numbers (dataIndexes) which indicates the selected rows
    rowsSelected: PersonaSelected,

    rowsPerPageOptions: [10, 20, 30],
    serverSide: true,
    count: totalRowsCount,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
    },
    onChangePage: (currentPage) => {
      setCurrentPage(currentPage);
    },
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
      },
      pagination: {
        next: "Próxima",
        previous: "Previa",
        rowsPerPage: "Filas:",
        displayRows: "de",
      },
    },
  };

  //
  // ################################################################################
  //
  const seleccionarPersona = (currentRowsSelected, allRowsSelected, rowsSelected
  ) => {
    setPersonaSelected(rowsSelected);
  };


  useEffect(() => {
    if (searchData.fecha_contrato_social) {
      setSelectedDate(new Date(searchData.fecha_contrato_social));
    }
  }, [searchData.fecha_contrato_social]);

  //
  // ################################################################################
  // cuando cambia la pagina actual o la cantidad de filas por pagina
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);

  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  //
  // ################################################################################
  //
  const handleChangeFechaCreacionDesde = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionDesde: fecha,
    });
  };

  //
  // ################################################################################
  //
  const handleChangeFechaCreacionHasta = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionHasta: fecha,
    });
  };

  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setTotalRowsCount(0);
    setPersonas([]);
    setPersonaSelected([]);
    setSearchData(initialSearchData);
    setSelectedDate(null);
  };

  //
  // ################################################################################
  //
  const handleBuscar = () => {
    load();
  };


  const handleDateChange = (date) => {
    setSearchData({ ...searchData, fecha_contrato_social: date });
    setSelectedDate(date);
  };

  //
  // ################################################################################
  // Funcion de busqueda .. 
  const load = async () => {

    let _params = {
      id: searchData.id,
      razon_social: searchData.razon_social,
      email: searchData.email,
      numero_inscripcion: searchData.numero_inscripcion,
      cuit: searchData.cuit,
      tipo_societario: searchData.tipo_societario,
      fecha_contrato_social: searchData.fecha_contrato_social,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,

    };

    setIsDoingSomething(true);
    const response = await getPersonasJuridicasHistorial(_params);
    setIsDoingSomething(false);
    if (response.ok) {
      let _personas = response.data.data;
      setTotalRowsCount(response.data.count);
      setPersonas(_personas);

    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };

  //
  // ###############################################################################
  //
  const obtienePersona = (dataIndex, parAction) => {
    let _id = personas[dataIndex].id;
    navigate("/personas/persona-juridica-historial/" + _id + "/" + parAction);

  };

  //
  // ################################################################################
  //
  const editaPersona = (dataIndex, parAction) => {
    let _id = personas[dataIndex].id;
    navigate("/personas/persona-juridica-historial/" + _id + "/" + parAction);

  }

  //
  // ################################################################################
  // habilito para que al precionar la tecla enter se ejecute la busqueda

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      console.log('ejecutando keydown');

      handleBuscar();
    }
  };

  return (
    <>

      <Paper elevation={0} sx={{ p: 1, m: 1, maxWidth: "100%" }}>

        <Paper elevation={3} sx={{ mb: 1 }}>
          <Box p={2}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: 2, mt: 2 }}>
                  <Typography variant="h4" display="block" gutterBottom>
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="cuit"
                  label="Cuit"
                  variant="outlined"
                  size="small"
                  name="cuit"
                  value={searchData.cuit}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>


              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="razon_social"
                  label="Razón Social"
                  variant="outlined"
                  size="small"
                  name="razon_social"
                  value={searchData.razon_social}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="email"
                  label="Correo Electrónico"
                  variant="outlined"
                  size="small"
                  name="email"
                  value={searchData.email}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2}> </Grid>
              <Grid item xs={12} md={6} lg={2}> </Grid>
              <Grid item xs={12} md={6} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="numero_inscripcion"
                  label="Número de Inscripción"
                  variant="outlined"
                  size="small"
                  name="numero_inscripcion"
                  value={searchData.numero_inscripcion}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2}>

                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    '& .MuiInputLabel-root': {
                      transform: 'translate(14px, 9px) scale(1)',
                    },
                    '& .MuiInputBase-root': {
                      paddingRight: '10px',
                    },
                    '& .MuiInputLabel-shrink': {
                      transform: 'translate(14px, -8px) scale(0.75)',
                    },
                  }}
                  size="small"
                  label="Fecha Contrato Social"
                  maxDate={new Date()}
                  minDate={new Date('1900-01-01')}
                  value={selectedDate}
                  onChange={(date) => {
                    setSelectedDate(date);
                    handleDateChange(date);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                    />
                  )}
                />

              </Grid>




              {/* ToggleButtonGroup para cambio de tipo de busqueda */}
              <Grid item xs={12} md={12} lg={12}></Grid>
              <Grid
                item
                xs={12}
                md={12}
                lg={8}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Box sx={{ display: "flex", gap: 1 }}>


                  <Tooltip title="Limpiar filtros">
                    <Button
                      fullWidth
                      sx={{ mt: 2 }}
                      variant="outlined"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>

                  <Tooltip title="Buscar">
                    <Button
                      fullWidth
                      sx={{ mt: 2 }}
                      variant="contained"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>

                </Box>
              </Grid>

            </Grid>

          </Box>
        </Paper >

        {isDoingSomething && <LinearProgress />}

        <MUIDataTable
          title={"Listado de Personas Físicas"}
          data={personas}
          columns={tableColumns}
          options={tableOptions}
        />

      </Paper >


      {/* >>>> Messages */}

      {
        showMessage && (
          <Message
            showMessage={showMessage}
            setShowMessage={setShowMessage}
            message={message}
          />
        )
      }
    </>
  );
};

export default PersonaJuridicaHistorialTable;
